import { Controller } from '@hotwired/stimulus';
import { eventListener } from '@inked/utilities';

export class SlideshowController extends Controller {
  static targets = [ 'dot', 'slide', 'track' ];
  static values = {
    current: {
      default: 0,
      type: Number,
    },
    loop: {
      default: false,
      type: Boolean,
    },
  };

  connect() {
    this.touch = {
      end: 0,
      lock: false,
      start: 0,
    };

    this.setTrackBoundary();
    this.setSlide(this.currentValue, true);

    this.stopTouchStartEvent = eventListener(this.trackTarget, 'touchstart', event => this.onTouchStart(event));
    this.stopTouchMoveEvent = eventListener(this.trackTarget, 'touchmove', event => this.onTouchMove(event));
    this.stopTouchEndEvent = eventListener(this.trackTarget, 'touchend', event => this.onTouchEnd(event));
  }

  disconnect() {
    this.stopTouchStartEvent();
    this.stopTouchMoveEvent();
    this.stopTouchEndEvent();
  }

  go(event) {
    this.setSlide(event.params.index);
  }

  handleSwipe() {
    const threshold = 50;
    const distance = this.touch.start - this.touch.end;

    if (distance > threshold) return this.next();
    if (distance < -threshold) this.previous();
  }

  next() {
    if (this.currentValue >= this.count - 1) {
      if (this.loopValue) this.setSlide(0);

      return;
    }

    this.setSlide(this.currentValue + 1);
  }

  onTouchEnd(event) {
    if (this.touch.lock) return this.touch.lock = false;

    this.touch.end = event.changedTouches[0].clientX;

    this.handleSwipe();
  }

  onTouchMove(event) {
    if (Math.abs(event.touches[0].clientX - this.touch.start) > 5) event.preventDefault();
  }

  onTouchStart(event) {
    if (event.touches.length === 2) return this.touch.lock = true;

    this.touch.start = event.touches[0].clientX;
  }

  previous() {
    if (this.currentValue === 0) {
      if (this.loopValue) this.setSlide(this.count - 1);

      return;
    }

    this.setSlide(this.currentValue - 1);
  }

  setAria(index) {
    [ this.slideTargets, this.dotTargets ].forEach((targets, typeIndex) => {
      targets.forEach((target, targetIndex) => {
        const active = targetIndex === index;

        if (typeIndex === 0) {
          target.ariaHidden = !active;

          return;
        }

        target.ariaCurrent = active;
      });
    });
  }

  setSlide(index, force = false) {
    if (this.currentValue === index && !force) return;

    this.currentValue = index;
    this.trackTarget.style.transform = `translate3d(-${(index / this.count) * 100}%, 0px, 0px)`;

    this.setAria(index);
  }

  setTrackBoundary() {
    this.trackTarget.style.width = `${100 * this.count}%`;
    this.trackTarget.style.display = 'grid';
    this.trackTarget.style.gridTemplateColumns = `repeat(${this.count}, 1fr)`;
  }

  get count() {
    return this.slideTargets.length;
  }
}
